<template>
    <div>
        <span class="b-admin-table__order-status-span" @dblclick="show_select" :class="{ active: !isActive }">
            {{ current_status.title }} <i v-show="show_warning" class="fa fa-warning"></i>
        </span>
        <select
                class="form-control input-sm b-admin-table__order-status-select"
                v-model="new_status"
                :class="{ active: isActive }"
        >
            <option :value="{ code: current_status.code, title: current_status.title }" selected>{{ current_status.title }}</option>
            <option v-for="status in statuses" :value="{ code: status.code, title: status.title }">
                {{ status.title }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        props: ['statuses', 'current_status', 'order_id', 'order_number', 'payment_was_failed'],
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        data: function () {
            return {
                isActive: false,
                new_status: { code: this.current_status.code, title: this.current_status.title }
            };
        },
        methods: {
            show_select: function () {
                this.$root.$emit('hide-all-selects');

                this.isActive = true;
            },
            hideAllSelectsEventHandler: function () {
                this.isActive = false;
            }
        },
        watch: {
            'new_status' : function(val) {
                if (val.hasOwnProperty('code')) {
                    if (confirm('Новый статус заказа № ' + this.order_number + ' - ' + val.title + '. Все верно?')) {
                        this.$root.$emit('change-status', { order_id: this.order_id, status_code: val.code });
                    }
                }
            }
        },
        computed: {
          show_warning: function () {
            return this.current_status.code === 'payable' && this.payment_was_failed;
          },
        },
        //EVENTS
        created: function () {
            this.$root.$on('hide-all-selects', this.hideAllSelectsEventHandler)
        },
        beforeDestroy: function () {
            this.$root.$off('hide-all-selects', this.hideAllSelectsEventHandler)
        }
    }
</script>
